import { Data } from '../../../models/index';
import { UseCase } from '../../UseCase';

export class GetDataStartOfWeek implements UseCase<Data, number> {
    execute(data: Data): number {
        switch (data.firstDay) {
            case 'sun':
                return 0;
            default:
            case 'mon':
                return 1;
            case 'tue':
                return 2;
            case 'wed':
                return 3;
            case 'thu':
                return 4;
            case 'fri':
                return 5;
            case 'sat':
                return 6;
        }
    }
}
